import { render, staticRenderFns } from "./AssetRiskTab.vue?vue&type=template&id=3debd700&"
import script from "./AssetRiskTab.vue?vue&type=script&lang=js&"
export * from "./AssetRiskTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports